<template>
  <SwitchingBehaviour
    :requires-analytics-text="tkey('requiresAnalyticsRun')"
    :job-type="prepareSwapsJob"
    :service-job-progress="serviceJobProgress"
    @run-prepare-swaps="runPrepareSwapsJob"
  />
</template>

<script>
import { getCurrentInstance } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';
import { usePrepareSwapsStatus } from '@/composables/use-prepare-swaps-status';
import { useScenariosStore } from '@/stores/scenarios';
import jobapi from '@enums/jobapi';
import { mapActions, mapState } from 'pinia';

export default {
  setup() {
    const { tkey } = useInternationalization('prepareSwaps');
    const instance = getCurrentInstance();
    const scenariosStore = useScenariosStore();
    const { serviceJobProgress, start: startPoller } = usePrepareSwapsStatus({
      getScenarioId: () => instance.proxy.$route.params.scenarioId,
      onTerminal: async () => {
        await scenariosStore.updateScenarioJobAndStatus();
      },
    });

    return { tkey, serviceJobProgress, startPoller };
  },
  data() {
    return { prepareSwapsJob: jobapi.jobTypes.prepareSwaps };
  },

  computed: { ...mapState(useScenariosStore, ['selectedScenario']) },

  methods: {
    ...mapActions(useScenariosStore, ['loadScenario', 'prepareSwaps']),

    async runPrepareSwapsJob() {
      await this.prepareSwaps();
      await this.refreshSelectedScenario();
      this.startPoller();
    },

    async refreshSelectedScenario() {
      await this.loadScenario(this.selectedScenario._id);
    },
  },
};
</script>
